import { render, staticRenderFns } from "./BsDatePickerHeader.vue?vue&type=template&id=173a9a13&"
import script from "./BsDatePickerHeader.vue?vue&type=script&lang=js&"
export * from "./BsDatePickerHeader.vue?vue&type=script&lang=js&"
import style0 from "./BsDatePickerHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports